import { createActions, handleActions } from 'redux-actions';

const SAVE_LOCALE = 'SAVE_LOCALE';

export const { saveLocale } = createActions({
  /**
   * Locale code in the format of: zh-tw, tw
   *
   * @param {String} [localeCode]
   * @param {String} [language]
   */
  [SAVE_LOCALE]: ({ language, localeCode, region }) => ({
    language,
    localeCode,
    region,
  }),
});

const INIT_STATE = {
  language: '',
  code: '',
  region: '',
};

const reducer = handleActions(
  {
    [saveLocale]: (state, action) => {
      const { localeCode, language, region } = action.payload;

      return {
        ...state,
        language,
        code: localeCode,
        region,
      };
    },
  },
  INIT_STATE
);

export default reducer;

// selectors
export const getLanguage = state => state.locale.language;
export const getLocaleCode = state => state.locale.code;
export const getRegion = state => state.locale.region;



// WEBPACK FOOTER //
// ./app/redux/locale.js